import InventoryRow from './InventoryRow';

export default InventoryRow;
